import { Paper, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import BarItemTooltip from "../BarItemTooltip";
import { formatCurrency } from "../formatters";
import { BrandMonthlyRow } from "./brandsApiMapping";

interface BrandsIncomeChartProps {
  rows: BrandMonthlyRow[];
  periodLabel: string;
}

// Still fed by the Monthly query (per the Brands tab update spec, Section
// 5, item 3 - this chart's data source did not change), only the label now
// reflects the selected Month/Year instead of a fixed "MTD".
export default function BrandsIncomeChart({ rows, periodLabel }: BrandsIncomeChartProps) {
  return (
    <Paper variant="outlined" sx={{ p: "18px 20px", borderColor: "#ececec" }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Total income by brand — {periodLabel}
      </Typography>
      <BarChart
        height={270}
        xAxis={[{ scaleType: "band", data: rows.map((row) => row.brand.replace(" Optifund", "")) }]}
        series={[
          {
            data: rows.map((row) => row.income),
            color: "#8E24AA",
            valueFormatter: (value) => (value === null ? "" : formatCurrency(value)),
          },
        ]}
        tooltip={{ trigger: "none" }}
      >
        <BarItemTooltip />
      </BarChart>
    </Paper>
  );
}
